// Products tab of the creator asset library page: the variant select follows
// the chosen product, rebuilt from the option's data-variants payload.
$(document).on("change", ".js-attach-product", function () {
  var variantSelect = document.querySelector(".js-attach-variant")
  if (!variantSelect) return

  variantSelect.innerHTML = ""
  variantSelect.add(new Option("All variants", ""))

  var selected = this.options[this.selectedIndex]
  var variants =
    selected && selected.getAttribute("data-variants")
      ? JSON.parse(selected.getAttribute("data-variants"))
      : []
  variants.forEach(function (variant) {
    variantSelect.add(new Option(variant.title, variant.id))
  })
})
